import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface ExportConsignedOrdersInterface {
  splitReferance?: string
}

export const useExportConsignedOrders = () => {
  const mutate = useMutation(
    ({ splitReferance }: ExportConsignedOrdersInterface) => {
      console.log('splitReferance', splitReferance)
      return postAPI(`/BulkConsignment/CsvList`, {
        splitReferance: splitReferance,
      })
    },
  )

  return mutate
}

export default useExportConsignedOrders
